// components/dialogs/OptionDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  TextField,
} from "@mui/material";

import Api from "../../Api/Api";
import { toast } from "sonner";

export default function OptionDialog({
  selectedCount,
  handleDelete,
  selectionModel,
  rows,
  columns,
}) {
  return (
    <>
      {selectedCount > 0 && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            left: "50%",
            transform: "translateX(-50%)",
            background: "#222",
            color: "#fff",
            padding: "12px 20px",
            borderRadius: "12px",
            display: "flex",
            gap: "12px",
          }}
        >
          <span>{selectedCount} selected</span>

          <Button variant="contained" color="error" onClick={handleDelete}>
            🗑 Delete
          </Button>

          {/* EXPORT SELECTED */}
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              const selectedIds = Array.from(selectionModel.ids);

              const selectedRows = rows.filter((row) =>
                selectedIds.includes(row.id),
              );

              if (!selectedRows.length) return;

              const visibleCols = columns.map((col) => col.field);

              const header = visibleCols.join(",");

              const csvRows = selectedRows.map((row) =>
                visibleCols
                  .map((field) => {
                    let value = row[field];

                    if (value === null || value === undefined) return "";

                    return `"${String(value).replace(/"/g, '""')}"`;
                  })
                  .join(","),
              );

              const csv = [header, ...csvRows].join("\n");

              const blob = new Blob([csv], {
                type: "text/csv;charset=utf-8;",
              });

              const url = URL.createObjectURL(blob);

              const link = document.createElement("a");

              link.href = url;
              link.setAttribute("download", "selected_rows.csv");

              document.body.appendChild(link);

              link.click();

              document.body.removeChild(link);
            }}
          >
            📥 Export
          </Button>
        </div>
      )}
    </>
  );
}
